  <template>
  <v-container
    grid-list-lg
    fill-height
    :style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center', backgroundSize: 'cover' }"
  >
    <v-layout align-center justify-center>
      <v-flex md12 xs12>
        <v-layout wrap>
          <v-flex xs12 text-xs-center>
            <h3>WORLD CLASS LECTURERS</h3>
          </v-flex>
          <!-- show on desktop -->
          <v-flex v-for="(lecturer, i) in lecturers" :key="i" md4 sm4 hidden-xs-only>
            <v-card height="400" :to="lecturer.link">
              <v-card-media
                contain
                :src="lecturer.media"
                height="200"></v-card-media>
              <v-card-title><strong>{{ lecturer.title }}</strong></v-card-title>
              <v-card-text>{{ lecturer.text }}</v-card-text>
            </v-card>
          </v-flex>
          <!-- show on mobile xs -->
          <v-flex v-for="(lecturer, i) in lecturers" :key="i" xs12 hidden-sm-and-up>
            <v-card :to="lecturer.link">
              <v-card-title><strong>{{ lecturer.title }}</strong></v-card-title>
              <v-card-text>{{ lecturer.text }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import lecturers from '@/server/lecturers.json'

export default {
  data () {
    return {
      bg: require('@/assets/bg/access.png'),
      lecturers: lecturers.items
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/home/slide3.vue